import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CustomerAuthPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Route to the portal root (PortalEntrypoint handles login form).
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
}